import { AlertColor } from "@mui/material";
import { create } from "zustand";

export interface IUserNotificationActions {
    setFeedbackMessage: (userFeedbackMessage : IUserFeedbackMessage) =>  void;
    clearFeedbackMessage: () => void;
}

export interface IUserFeedbackMessage {
    message: string;
    severity: AlertColor;
}

export interface IUserNotificationState {
    feedbackMessage: IUserFeedbackMessage | null;
    actions: IUserNotificationActions;
}

const useUserNotificationStore = create<IUserNotificationState>( (set) => ({
    feedbackMessage: null,
    actions: {
        setFeedbackMessage: (userFeedbackMessage: IUserFeedbackMessage) =>  set({ feedbackMessage:userFeedbackMessage }),
        clearFeedbackMessage: () => set({feedbackMessage: null})
    }
}));

export const useUserNotificationStoreFeedbackMessage = () => useUserNotificationStore((state) => state.feedbackMessage);
export const useUserNotificationActions = () => useUserNotificationStore((state) => state.actions);